import { ItemVariation } from './ItemVariation';
import utils from "@/app/shared/utils/utils.js";
import { NamingTemplates } from './NamingTemplates';

export class Item {
	static videoSizes = [
		{ name: "S", simpleTitle: "1:1", title: "S (1:1)", defaultWidth: 1080, defaultHeight: 1080, defaultR: 1 },
		{ name: "F", simpleTitle: "4:5", title: "F (4:5)", defaultWidth: 1080, defaultHeight: 1350, defaultR: 0.8 },
		{ name: "P", simpleTitle: "2:3", title: "P (2:3)", defaultWidth: 1080, defaultHeight: 1620, defaultR: 0.67 },
		{ name: "V", simpleTitle: "9:16", title: "V (9:16)", defaultWidth: 1080, defaultHeight: 1920, defaultR: 0.56 },
		{ name: "H", simpleTitle: "16:9", title: "H (16:9)", defaultWidth: 1920, defaultHeight: 1080, defaultR: 1.78 }
	];

	/* 	static outsizeVideoSizes = [
			//long - длинный(вытянутый), wide - широкий(сплющенный)
			{ name: "LS", title: "long S", defaultWidth: 1080, defaultHeight: null, defaultR: 1 },
			{ name: "RS", title: "wide S", defaultWidth: null, defaultHeight: 1080, defaultR: 1 },
			{ name: "LF", title: "long F", defaultWidth: 1080, defaultHeight: null, defaultR: 0.8 },
			{ name: "RF", title: "wide F", defaultWidth: null, defaultHeight: 1350, defaultR: 0.8 },
			{ name: "LV", title: "long V", defaultWidth: 1080, defaultHeight: null, defaultR: 0.56 },
			{ name: "RV", title: "wide V", defaultWidth: null, defaultHeight: 1920, defaultR: 0.56 },
			{ name: "LH", title: "long H", defaultWidth: 1920, defaultHeight: null, defaultR: 1.78 },
			{ name: "RH", title: "wide H", defaultWidth: null, defaultHeight: 1080, defaultR: 1.78 },
			{ name: "LP", title: "long P", defaultWidth: 1080, defaultHeight: null, defaultR: 0.67 },
			{ name: "RP", title: "wide P", defaultWidth: null, defaultHeight: 1620, defaultR: 0.67 }
		]; */

	static outsizeVideoSizes = [
		//long - длинный(вытянутый), wide - широкий(сплющенный)
		{ name: "LS", simpleTitle: "1:1", title: "long S", defaultWidth: 1080, defaultHeight: null, defaultR: 1 },
		{ name: "RS", simpleTitle: "1:1", title: "wide S", defaultWidth: null, defaultHeight: 1080, defaultR: 1 },
		{ name: "LF", simpleTitle: "4:5", title: "long F", defaultWidth: 1080, defaultHeight: null, defaultR: 0.8 },
		{ name: "RF", simpleTitle: "4:5", title: "wide F", defaultWidth: 1080, defaultHeight: null, defaultR: 0.8 },
		{ name: "LV", simpleTitle: "9:16", title: "long V", defaultWidth: 1080, defaultHeight: null, defaultR: 0.56 },
		{ name: "RV", simpleTitle: "9:16", title: "wide V", defaultWidth: 1080, defaultHeight: null, defaultR: 0.56 },
		{ name: "LH", simpleTitle: "16:9", title: "long H", defaultWidth: null, defaultHeight: 1080, defaultR: 1.78 },
		{ name: "RH", simpleTitle: "16:9", title: "wide H", defaultWidth: null, defaultHeight: 1080, defaultR: 1.78 },
		{ name: "LP", simpleTitle: "2:3", title: "long P", defaultWidth: 1080, defaultHeight: null, defaultR: 0.67 },
		{ name: "RP", simpleTitle: "2:3", title: "wide P", defaultWidth: 1080, defaultHeight: null, defaultR: 0.67 }
	];

	static presets = [
		{ name: "crop", simpleTitle: "Crop", title: "Crop" },
		{ name: "blur", simpleTitle: "Blur", title: "Blur" },
		{ name: "tile", simpleTitle: "Tile", title: "Tile" },
		{ name: "color", simpleTitle: "Color", title: "Color" },
		/* { name: "image", simpleTitle: "Image", title: "Image" }, */
	];

	checked: boolean;
	id: string;
	loadingParameters: any;

	fileId: number;
	name: string;
	src: string;
	localSrc: string;
	inputSize: any;

	innerVideoResolutionX: number;
	innerVideoResolutionY: number;

	fps: number;
	duration: number;
	size: number;
	bitrate: number;
	thumbs: string[];

	variations: ItemVariation[];

	isOutsize: boolean;
	isForSlice: boolean;

	isFromUA: boolean;

	currentVariation: ItemVariation;

	constructor() {
		this.id = `f${(~~(Math.random() * 1e8)).toString(16)}`;
		this.fileId = 0;
		this.name = '';
		this.src = '';
		this.localSrc = null;
		this.inputSize = null;

		this.loadingParameters = {
			loaded: false,
			uploadingId: "",
			process: 0,
			uploadedType: 2
			/*
			1 - "dragndrop",
			2 - "upload from pc",
			3 - "UA",
			4 - "URL"
			*/
		}

		this.innerVideoResolutionX = 0;
		this.innerVideoResolutionY = 0;

		this.fps = 0;
		this.duration = 0;
		this.size = 0;
		this.bitrate = 0;
		this.thumbs = [];

		this.variations = [];

		this.isOutsize = false;

		this.isForSlice = false;
		this.isFromUA = false;
	}

	static createNewItemByFile(file: File, videoFileParameters: any, uploadingId: string, uploadedTypeId: number, enableSlicerByDefault: boolean) {
		let newItem = new Item();

		newItem.fileId = null;
		newItem.name = file.name.split('.').slice(0, -1).join('.');
		newItem.src = null;
		newItem.localSrc = window.URL.createObjectURL(file);
		newItem.inputSize = null;

		newItem.loadingParameters = {
			loaded: false,
			uploadingId: uploadingId,
			process: 0,
			uploadedType: uploadedTypeId
		}

		newItem.innerVideoResolutionX = videoFileParameters.videoWidth;
		newItem.innerVideoResolutionY = videoFileParameters.videoHeight;

		newItem.fps = 0;
		newItem.duration = videoFileParameters.duration;
		newItem.size = 0;
		newItem.bitrate = 0;
		newItem.thumbs = [];

		let r = utils.methods.calcStrSize(newItem.innerVideoResolutionX / newItem.innerVideoResolutionY);
		newItem.isOutsize = r.length === 2;
		newItem.inputSize = JSON.parse(JSON.stringify(Item.getVideoSize(r)));
		newItem.isForSlice = enableSlicerByDefault && newItem.innerVideoResolutionX === 1920 && newItem.innerVideoResolutionY === 1920;
		newItem.isFromUA = false;

		return newItem;
	}

	parseToShortObject() {
		return {
			id: this.id,
			fileId: this.fileId,
			name: this.name,
			isOutsize: this.isOutsize,
			isForSlice: this.isForSlice,
			inputSize: this.inputSize,
			innerVideoResolutionX: this.innerVideoResolutionX,
			innerVideoResolutionY: this.innerVideoResolutionY,
			fps: this.fps,
			duration: this.duration,
			size: this.size,
			bitrate: this.bitrate,
			isFromUA: false
		};
	}

	switchSlicerMode(isForSlice) {
		if (this.isForSlice === isForSlice) {
			return;
		} else {
			this.isForSlice = isForSlice;
			const updatedParentItem = this.parseToShortObject();
			this.variations.forEach(variation => {
				variation.parentItem = updatedParentItem;
				variation.currentSize = JSON.parse(JSON.stringify(Item.videoSizes.find((size) => size.name === variation.currentSize.name)));
				if (this.isForSlice) {
					variation.preset = { name: 'slicer', title: 'Slicer' };
				} else {
					if (variation.currentSize.name === this.inputSize.name) {
						variation.currentSize.simpleTitle = variation.currentSize.simpleTitle + "*";
						variation.currentSize.title = "Original";
					}

					variation.preset = ItemVariation.getInitialResizerPreset(this.inputSize.name + '_' + variation.currentSize.name);
				}
				variation.recalcOuterVideoResolutions();
				variation.calcVideoPreviewPositon(
					variation.preset.name
				);

				let maxShifts = variation.getMaxShifts();
				variation.previewParameters.verticalShift = maxShifts.maxVerticalShift !== 0 ? maxShifts.maxVerticalShift / 2 : 0;
				variation.previewParameters.horizontalShift = maxShifts.maxHorizontalShift !== 0 ? maxShifts.maxHorizontalShift / 2 : 0;
				variation.clearShiftsAndZoom();

				variation.recalcFileOutputParameters();
			});
		}
	}

	static copyFromParsed(itemToCopy): Item {
		let newItem = new Item();

		newItem.fileId = itemToCopy.fileId;
		newItem.checked = itemToCopy.checked;
		newItem.name = itemToCopy.name;
		newItem.src = itemToCopy.src;

		//WARN: Don't update local src. After parsing it will be null!
		newItem.localSrc = null;

		newItem.loadingParameters.loaded = true
		newItem.loadingParameters.process = 100;
		newItem.loadingParameters.uploadedType = !!itemToCopy.isFromUA
			?
			3
			: !!itemToCopy.loadingParameters.uploadedType
				? itemToCopy.loadingParameters.uploadedType
				: 2;

		//newItem.inputSize = JSON.parse(JSON.stringify(itemToCopy.inputSize));
		newItem.inputSize = JSON.parse(JSON.stringify(Item.getVideoSize(itemToCopy.inputSize.name)));

		newItem.innerVideoResolutionX = itemToCopy.innerVideoResolutionX;
		newItem.innerVideoResolutionY = itemToCopy.innerVideoResolutionY;

		newItem.fps = itemToCopy.fps;
		newItem.duration = itemToCopy.duration;
		if (itemToCopy.size) {
			newItem.size = itemToCopy.size;
		}
		if (itemToCopy.bitrate) {
			newItem.bitrate = itemToCopy.bitrate;
		}
		newItem.thumbs = JSON.parse(JSON.stringify(itemToCopy.thumbs));

		newItem.isOutsize = itemToCopy.isOutsize;

		newItem.isForSlice = itemToCopy.isForSlice;

		newItem.isFromUA = !!itemToCopy.isFromUA;

		newItem.variations = [];
		itemToCopy.variations.forEach(variation => {
			let newVariation = ItemVariation.copyFromParsed(variation);
			newVariation.parentItem = newItem.parseToShortObject();
			newVariation.recalcZoomParams();
			newItem.variations.push(newVariation);
			//newVariation.checkAndUpdateWatermarkTime();
			//newVariation.checkAndUpdateStickersTime();
			//newVariation.checkAndUpdateOverlayVideoTime();
			//newVariation.checkAndUpdateTextTime();
			if (newVariation.currentSize.simpleTitle === "Original") {
				let sizeR = Math.round(itemToCopy.innerVideoResolutionX / itemToCopy.innerVideoResolutionY * 100) / 100;
				newVariation.currentSize.simpleTitle = !itemToCopy.isOutsize ? newItem.inputSize.simpleTitle + "*" : "1:" + sizeR + "*";
			}
			if (newVariation.fileOutputParameters.bitrate === 0) {
				newVariation.recalcFileOutputParameters();
			}
		});
		newItem.currentVariation = newItem.variations[0];

		return newItem;
	}

	getPresets() {
		return Item.presets;
	}

	static getVideoSize(name) {
		return name.length === 1
			? this.videoSizes.find(item => item.name === name.toUpperCase())
			: this.outsizeVideoSizes.find(item => item.name === name.toUpperCase());
	}

	getVideoSizes(excludeName?, renameToOriginal?) {
		if (this.isOutsize) {
			let s = ItemVariation.getInitialResizerSize(this.inputSize.name);
			let newS = JSON.parse(JSON.stringify(s));
			let sizeR = Math.round(this.innerVideoResolutionX / this.innerVideoResolutionY * 100) / 100;
			newS.simpleTitle = "1:" + sizeR + "*";
			newS.title = "Original";
			//return [newS, s];
			return [newS, ...Item.videoSizes];
		}
		if (renameToOriginal) {
			let sizes = Item.videoSizes.map(s => {
				if (s.name === excludeName) {
					let newS = JSON.parse(JSON.stringify(s));
					newS.simpleTitle = this.inputSize.simpleTitle + "*";
					newS.title = "Original";
					return newS;
				} else {
					return JSON.parse(JSON.stringify(s));
				};
			});
			let original = sizes.find(s => s.title === "Original");
			sizes.splice(sizes.indexOf(original), 1);
			sizes.unshift(original);
			return sizes;
		} else {
			return !excludeName ? Item.videoSizes : Item.videoSizes.filter(item => item.name !== excludeName.toUpperCase());
		}
	}

	addNewVariation(isSaveOriginalName, outputNameTemplate, sizeName?) {
		let itemVariation = new ItemVariation();
		itemVariation.parentItem = this.parseToShortObject();
		itemVariation.isSaveOriginalName = this.isFromUA ? true : isSaveOriginalName;
		itemVariation.outputNameTemplate = outputNameTemplate;
		itemVariation.currentSize = sizeName && !this.isOutsize
			? JSON.parse(JSON.stringify(Item.videoSizes.find((size) => size.name === sizeName)))
			: JSON.parse(JSON.stringify(ItemVariation.getInitialResizerSize(this.inputSize.name)));
		if (this.isForSlice) {
			itemVariation.preset = { name: 'slicer', title: 'Slicer' };
		} else {
			itemVariation.preset = ItemVariation.getInitialResizerPreset(this.inputSize.name + '_' + itemVariation.currentSize.name);
		}
		itemVariation.recalcOuterVideoResolutions();
		itemVariation.calcVideoPreviewPositon(
			itemVariation.preset.name
		);

		itemVariation.cut = {
			startTime: 0,
			finishTime: this.duration
		};
		//itemVariation.checkAndUpdateWatermarkTime();
		//itemVariation.checkAndUpdateStickersTime();
		//itemVariation.checkAndUpdateOverlayVideoTime();
		//itemVariation.checkAndUpdateTextTime();

		let maxShifts = itemVariation.getMaxShifts();
		itemVariation.previewParameters.verticalShift = maxShifts.maxVerticalShift !== 0 ? maxShifts.maxVerticalShift / 2 : 0;
		itemVariation.previewParameters.horizontalShift = maxShifts.maxHorizontalShift !== 0 ? maxShifts.maxHorizontalShift / 2 : 0;
		itemVariation.clearShiftsAndZoom();

		//itemVariation.recalcOuterVideoResolutions();
		this.variations.push(itemVariation);
		this.currentVariation = itemVariation;
		itemVariation.recalcFileOutputParameters();
	}
}
